"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Tesla = void 0;
var UnitDivide = require("../unit-divide");
var magnetic_flux_1 = require("./magnetic-flux");
var area_1 = require("./area");
/**
 * The derived unit for magnetic flux density ( <code>T</code> ).
 * One Tesla is equal equal to one weber per square meter.
 * It is named after the Serbian-born American electrical engineer and physicist Nikola Tesla (1856-1943).
 */
exports.Tesla = UnitDivide.magneticFluxByArea("Tesla", magnetic_flux_1.Weber, area_1.SquareMeter);
//# sourceMappingURL=magnetic-flux-density.js.map